import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsOrderOffer = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
    

	<path fill="currentColor" d="M23.3668518,15.5155115l-0.0022202-1.1144848l-10.2279463,3.1525259
	c-0.1798267-0.4906406-0.4573383-0.9324379-0.8103323-1.3031921l10.5387592-3.210248L20.9158745,5.127718L16.9530182,6.337666
	l-1.187748-4.7576494L7.2334709,4.1841807l1.2343693,4.9485765l1.469698,5.9609375
	c-0.113224-0.0111008-0.2308884-0.0155411-0.3463335-0.0155411c-0.3130331,0-0.6194048,0.0377417-0.9102364,0.1110039
	L5.834815,3.5248134V3.3294456H5.6683087L0.9839222,1.3735478L0.6331483,2.3681474L5.000062,4.1641989l2.7795506,11.3779526
	c-1.1677666,0.6416063-1.9603381,1.8826342-1.9603381,3.3101511c0,2.0846634,1.689487,3.7741489,3.7741504,3.7741489
	s3.7741499-1.6894855,3.7741499-3.7741489c0-0.0777035-0.0022192-0.155407-0.0066595-0.2308903l10.0059366-3.1059036V15.5155115z
	 M8.4278774,4.9234705l6.646944-2.0424814l0.9213371,3.698667L9.3492146,8.622138L8.4278774,4.9234705z M9.5912037,9.6833391
	l10.6342239-3.252429l1.4430561,5.8454924l-10.4166546,3.1858263c-0.0865831-0.0421829-0.1731663-0.0821438-0.2619696-0.1176643
	L9.5912037,9.6833391L9.5912037,9.6833391z M9.5601225,21.7650604c-1.5940237,0-2.8861146-1.2920933-2.8861146-2.886116
	s1.2920918-2.8861141,2.8861146-2.8861141s2.8861141,1.2920914,2.8861141,2.8861141S11.1541452,21.7650604,9.5601225,21.7650604
	L9.5601225,21.7650604z"/>
    </SvgIcon>
  );
});

export default AppIconsOrderOffer;
